/**
 * Created by Ning Jiang on 2023-09-14.
 */
import {WinPresentationController} from "../WinPresentationController";
import {DevilsCrossRoad} from "../../DevilsCrossRoad";
import {gsap} from "gsap";
import {DevilsCrossRoadSound} from "../../sound/DevilsCrossRoadSound";

export class RandomWildsController extends WinPresentationController {

    private _playOrder:[number, number][] = [[1, 2], [2, 1], [3, 2], [2, 3]];

    constructor() {
        super("RandomWildsController", false);
    }

    protected hasWin():boolean {
        return DevilsCrossRoad.model.randomWilds?.length > 0;
    }

    protected async createWinAnimation():Promise<any> {
        const tl = gsap.timeline();
        this._playOrder.forEach(coord => {
            if(DevilsCrossRoad.model.randomWilds.some(w => w[0] === coord[0] && w[1] === coord[1])) {
                const oldSym = DevilsCrossRoad.reels.getSymbol(coord[0], coord[1])!;
                const quadTl = gsap.timeline();
                quadTl.add([
                    () => {
                        DevilsCrossRoadSound.soundPlayer.playTrack({name : DevilsCrossRoadSound.WILD_LAND});
                        DevilsCrossRoad.backgroundElements.setMainFrame("glow_fast", false);
                    },
                    DevilsCrossRoad.reels.replaceSymbol(oldSym, "W"),
                    DevilsCrossRoad.devil.playWild()
                ]);
                tl.add(quadTl);
            }
        });
        if(tl.totalDuration() > 0) {
            await tl;
        }
    }
}